// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../fonts/Urbanist-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Urbanist';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); }

.county-climate {
  color: #fff;
  background-color: #050e25;
  height: 100vh;
  width: 100%;
  margin: 0px;
  padding: 0px;
  padding-left: 30px;
  padding-right: 30px;
  padding-top: 10px; }
  .county-climate h2 {
    font-weight: 600; }
  .county-climate .expand-container {
    position: absolute;
    top: 65px;
    left: 70px;
    height: 90vh !important;
    width: 95% !important;
    z-index: 100; }
  .county-climate .expand-container .table-container {
    max-height: 80vh !important; }
  .county-climate .fullscreen,
  .county-climate .more-options {
    background-color: unset;
    border: unset; }
    .county-climate .fullscreen img,
    .county-climate .more-options img {
      filter: invert(1); }
  .county-climate .expand-chart-container {
    position: absolute !important;
    top: 80px;
    left: 95px;
    height: 90vh !important;
    width: 92% !important;
    z-index: 100;
    margin-top: 0px;
    max-height: none !important; }
  .county-climate .expand-summary-container {
    position: absolute !important;
    top: 60px;
    left: 95px;
    height: 89vh !important;
    width: 94% !important;
    z-index: 100;
    margin-top: 0px;
    max-height: none !important; }
  .county-climate .fullscreen:hover {
    filter: invert(80%) sepia(51%) saturate(6275%) hue-rotate(196deg) brightness(102%) contrast(104%); }
  .county-climate .more-options:hover {
    filter: invert(80%) sepia(51%) saturate(6275%) hue-rotate(196deg) brightness(102%) contrast(104%); }
  .county-climate .container-row-top {
    margin-top: 10px;
    height: 40vh; }
  .county-climate .container-row-bottom {
    margin-top: 15px;
    height: 40vh; }
  .county-climate .chart-container {
    height: 100%;
    width: 100%;
    width: -webkit-fill-available;
    width: -moz-available;
    width: stretch;
    max-height: 40vh; }
  .county-climate .chart-parent-container {
    height: 100%;
    width: 100%;
    width: -webkit-fill-available;
    width: -moz-available;
    width: stretch; }
  .county-climate .map-report-container {
    background-color: #0b1736;
    border-radius: 2px;
    box-shadow: 0px 0px 20px #000;
    display: flex;
    position: relative;
    height: 100%; }
  .county-climate .column-summary {
    min-width: 120px; }
  .county-climate .column-chart {
    margin-left: 10px; }
  .county-climate .column-container {
    max-width: 50%; }
  .county-climate .summary-container {
    background-color: #0b1736;
    border-radius: 2px;
    box-shadow: 0px 0px 20px #000;
    display: flex;
    margin-top: 0px;
    margin-left: 0px;
    position: relative;
    padding-top: 0px;
    min-width: 120px;
    overflow-x: hidden;
    overflow-y: auto;
    flex-direction: column;
    border-radius: 7px;
    font-size: 1.4rem; }
  .county-climate .summary-container {
    height: 100%;
    width: 100%;
    width: -webkit-fill-available;
    width: -moz-available;
    width: stretch;
    max-height: 40vh; }
  .county-climate .resultBox-span {
    color: #49b4cd; }
  .county-climate .resultBox {
    margin-top: 5px;
    margin-left: 20px;
    font-size: 1.2rem; }
  .county-climate .resultBoxDescriptor {
    border-radius: 15px;
    padding: 6px;
    margin-top: 10px;
    width: 100%;
    background-color: #021b3a;
    font-family: Helvetica, Arial, sans-serif;
    padding: 5px;
    display: inline-block;
    color: white; }
  .county-climate .resultsDetail {
    border-radius: 15px;
    padding: 6px;
    margin: 2px;
    width: 100%;
    background-color: #021b3a;
    font-family: Helvetica, Arial, sans-serif;
    padding: 5px;
    display: inline-block;
    clear: both; }
  .county-climate .resultBox {
    border-radius: 15px;
    padding: 6px;
    margin-top: 10px;
    background-color: #021b3a;
    font-family: Helvetica, Arial, sans-serif;
    padding: 5px;
    display: inline-block;
    width: 100%; }
  .county-climate .resultBoxRow {
    display: inline-flex;
    flex-direction: row; }
  .county-climate .output {
    width: 160px;
    padding: 5px 35px 5px 5px;
    font-size: 1.4rem;
    color: #49b4cd;
    height: 34px;
    margin-left: 5px; }
  .county-climate .outputLabel {
    color: white;
    padding: 5px 10px 5px 5px;
    font-size: 1rem;
    /* min-width:50px; */
    min-width: 90px;
    display: inline-block; }
  .county-climate .widgetTitle {
    margin-top: 4px;
    margin-left: 8px; }
  .county-climate .summary-container-secondary {
    margin-top: 20px; }
  .county-climate .summary-title {
    display: flex;
    width: 110px;
    white-space: break-spaces;
    text-align: center;
    margin-bottom: 1px; }
  .county-climate .summary-title Button {
    display: none;
    margin-left: 15px;
    background-color: #fff;
    border: unset; }
  .county-climate .summary-title img {
    vertical-align: unset !important; }
  .county-climate .summary-title Button:hover {
    background-color: #257ee0; }
  .county-climate .summary-button {
    display: none;
    width: 44px;
    display: inline-flex;
    align-self: flex-end;
    background-color: white; }
  .county-climate .summary-container-span {
    font-size: 1.2rem; }
  .county-climate .summary-top {
    width: 100px; }
  .county-climate .summary-field-name {
    font-size: 12px;
    color: gray;
    padding-bottom: 5px; }
  .county-climate .summary-field-double {
    height: auto;
    line-height: 18px; }
  .county-climate .mapboxgl-popup {
    z-index: 22; }
  .county-climate .mapboxgl-popup-content {
    padding: 0px !important;
    opacity: .95;
    border-radius: 4px;
    width: 100% !important;
    background-color: #18244c; }
  .county-climate .mapboxgl-popup-anchor-top .mapboxgl-popup-tip {
    border-bottom-color: #050E25;
    opacity: .8; }
  .county-climate .mapboxgl-popup-close-button {
    display: none; }
  .county-climate .popup-container {
    background-color: black;
    opacity: .95;
    text-align: center;
    height: auto;
    padding-top: 10px;
    padding-bottom: 18px;
    padding-left: 10px;
    padding-right: 4px;
    font-size: 1.2rem;
    min-width: 210px;
    line-height: 1.2rem;
    font-family: "Urbanist";
    background-color: #050E25;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: max-content; }
    .county-climate .popup-container h2 {
      font-size: 22px;
      color: #49b4cd; }
  .county-climate .popup-content-left {
    text-align: right;
    margin-right: 10px;
    width: 75px;
    white-space: normal; }
  .county-climate .popup-content-right {
    text-align: left;
    width: 200px; }
  .county-climate .popup-content-right-double {
    height: 32px;
    line-height: 18px;
    margin-bottom: 25px; }
  .county-climate .popup-content-row {
    display: inline-flex;
    flex-direction: row;
    height: auto;
    justify-content: space-between;
    margin-bottom: 7px; }
  .county-climate .popup-content-label {
    width: 100px;
    min-width: 100px !important;
    margin-right: 5px;
    text-align: end; }
  .county-climate .popup-content-value {
    margin-left: 5px;
    width: 160px;
    max-width: 160px !important;
    text-align: start;
    height: auto; }
  .county-climate .popup-container-location {
    color: #4fc2d9; }
  .county-climate .popup-container h4 {
    font-size: 22px;
    line-height: 22px;
    height: auto;
    color: #4fc2d9; }
  .county-climate .map-title {
    width: auto;
    white-space: nowrap;
    position: absolute;
    left: 50px;
    top: 0px;
    font-size: 1.25rem;
    padding: 5px;
    z-index: 90; }
  .county-climate .map-legend {
    width: 125px;
    min-height: auto;
    position: absolute;
    border-radius: 5px;
    padding: 5px;
    right: 30px;
    bottom: 5px;
    background-color: #18244c;
    z-index: 90; }
  .county-climate .accordion-button {
    color: white;
    background-color: #18244c;
    border: 0px !important;
    padding: .5rem .5rem; }
  .county-climate .climate-slider {
    display: inline-block;
    width: 330px;
    align-self: center; }
  .county-climate .climate-slider-container {
    width: 100%;
    position: absolute;
    bottom: 30px;
    text-align: center;
    padding-right: 10px;
    height: 90px;
    display: inline-flex;
    flex-direction: column; }
  .county-climate .climate-slider-container-span {
    width: 100%;
    color: white !important;
    -webkit-text-stroke-width: 1.2px;
    -webkit-text-stroke-color: #060e21;
    text-align: center;
    font-size: 1.5rem;
    margin-bottom: 7px; }
  .county-climate .rc-slider-mark-text {
    color: white !important;
    -webkit-text-stroke-width: 1.4px;
    -webkit-text-stroke-color: black;
    font-size: 1.2rem  !important;
    font-weight: 700;
    text-shadow: unset !important; }
  .county-climate .chart-container-parent {
    margin-left: 10px; }
  .county-climate .chart-container {
    position: relative;
    background-color: #0b1736;
    border-radius: 2px;
    box-shadow: 0px 0px 20px #000; }
  .county-climate .line-chart {
    height: 100%; }
  .county-climate .report-chart-options-camel {
    position: absolute;
    margin-top: 5px;
    text-align: right;
    right: 10px; }
    .county-climate .report-chart-options-camel button {
      background-color: #fff;
      border: unset; }
      .county-climate .report-chart-options-camel button img {
        padding-bottom: 3px; }
    .county-climate .report-chart-options-camel .btn-light:hover {
      background-color: #257ee0; }
  .county-climate .report-chart-options-storm {
    position: absolute;
    margin-top: 5px;
    text-align: right;
    right: 10px; }
    .county-climate .report-chart-options-storm button {
      background-color: #fff;
      border: unset; }
      .county-climate .report-chart-options-storm button img {
        padding-bottom: 3px; }
    .county-climate .report-chart-options-storm .btn-light:hover {
      background-color: #257ee0; }
  .county-climate .report-chart-options-summary {
    position: absolute;
    margin-top: 5px;
    text-align: right;
    right: 10px; }
    .county-climate .report-chart-options-summary button {
      background-color: #fff;
      border: unset; }
      .county-climate .report-chart-options-summary button img {
        padding-bottom: 3px; }
    .county-climate .report-chart-options-summary .btn-light:hover {
      background-color: #257ee0; }

@media only screen and (min-device-width: 768px) and (max-device-width: 1366px) and (orientation: portrait) {
  .county-climate .header-container h2 {
    font-size: 23px; }
  .line-chart {
    position: relative; }
    .line-chart canvas {
      position: absolute;
      padding: 3rem;
      top: 1%; }
  .container-q3 {
    position: relative; }
    .container-q3 .line-q3 {
      padding: 2rem;
      position: absolute;
      top: 2%; } }
`, "",{"version":3,"sources":["webpack://./src/theme/_variables.scss","webpack://./src/features/reports/ClimatePrecipitationCalculator/styles.scss"],"names":[],"mappings":"AAqBA;EACE,uBAAuB;EACvB,4CAAmD,EAAA;;ACdrD;EACE,WDVqB;ECWrB,yBDEsC;ECDtC,aAAa;EACb,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAdoB;EAepB,mBAfoB;EAgBpB,iBAfmB,EAAA;EAMrB;IAaI,gBAAgB,EAAA;EAbpB;IAiBI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,uBAAuB;IACvB,qBAAqB;IACrB,YAAY,EAAA;EAtBhB;IA0BI,2BAA2B,EAAA;EA1B/B;;IA+BI,uBAAuB;IACvB,aAAa,EAAA;IAhCjB;;MAmCM,iBAAiB,EAAA;EAnCvB;IAwCI,6BAA6B;IAC7B,SAAS;IACT,UAAU;IACV,uBAAuB;IACvB,qBAAqB;IACrB,YAAY;IACZ,eAAe;IACf,2BAA2B,EAAA;EA/C/B;IAmDI,6BAA6B;IAC7B,SAAS;IACT,UAAU;IACV,uBAAuB;IACvB,qBAAqB;IACrB,YAAY;IACZ,eAAe;IACf,2BAA2B,EAAA;EA1D/B;IA8DI,iGAAiG,EAAA;EA9DrG;IAkEI,iGAAiG,EAAA;EAlErG;IAsEI,gBAAgB;IAChB,YAAY,EAAA;EAvEhB;IA2EI,gBAAgB;IAChB,YAAY,EAAA;EA5EhB;IAgFI,YAAY;IACZ,WAAW;IAEX,6BAA6B;IAC7B,qBAAc;IAAd,cAAc;IACd,gBAAgB,EAAA;EArFpB;IAyFI,YAAY;IACZ,WAAW;IAEX,6BAA6B;IAC7B,qBAAc;IAAd,cAAc,EAAA;EA7FlB;IAiGI,yBDvG4B;ICwG5B,kBAAkB;IAClB,6BAA6B;IAC7B,aAAa;IACb,kBAAkB;IAClB,YAAY,EAAA;EAtGhB;IA0GI,gBAAgB,EAAA;EA1GpB;IA8GI,iBAAiB,EAAA;EA9GrB;IAkHI,cAAc,EAAA;EAlHlB;IAsHI,yBD5H4B;IC6H5B,kBAAkB;IAClB,6BAA6B;IAC7B,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB,EAAA;EAnIrB;IAuII,YAAY;IACZ,WAAW;IAEX,6BAA6B;IAC7B,qBAAc;IAAd,cAAc;IACd,gBAAgB,EAAA;EA5IpB;IAgJI,cAAc,EAAA;EAhJlB;IAoJI,eAAe;IACf,iBAAiB;IACjB,iBAAiB,EAAA;EAtJrB;IA0JI,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,yBAAyB;IACzB,yCAAyC;IACzC,YAAY;IACZ,qBAAqB;IACrB,YAAY,EAAA;EAlKhB;IAsKI,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,yCAAyC;IACzC,YAAY;IACZ,qBAAqB;IACrB,WAAW,EAAA;EA9Kf;IAkLI,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;IACzB,yCAAyC;IACzC,YAAY;IACZ,qBAAqB;IACrB,WAAW,EAAA;EAzLf;IA6LI,oBAAoB;IACpB,mBAAmB,EAAA;EA9LvB;IAkMI,YAAY;IACZ,yBAAyB;IACzB,iBAAiB;IACjB,cAAc;IACd,YAAY;IACZ,gBAAgB,EAAA;EAvMpB;IA2MI,YAAY;IACZ,yBAAyB;IACzB,eAAe;IACf,oBAAA;IACA,eAAe;IACf,qBAAqB,EAAA;EAhNzB;IAoNI,eAAe;IACf,gBAAgB,EAAA;EArNpB;IAyNI,gBAAgB,EAAA;EAzNpB;IA6NI,aAAa;IACb,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB,EAAA;EAjOtB;IAqOI,aAAa;IACb,iBAAiB;IACjB,sBAAsB;IACtB,aAAa,EAAA;EAxOjB;IA4OI,gCAAgC,EAAA;EA5OpC;IAgPI,yBAAyB,EAAA;EAhP7B;IAoPI,aAAa;IACb,WAAW;IACX,oBAAoB;IACpB,oBAAoB;IACpB,uBAAuB,EAAA;EAxP3B;IA4PI,iBAAiB,EAAA;EA5PrB;IAgQI,YAAY,EAAA;EAhQhB;IAoQI,eAAe;IACf,WAAW;IACX,mBAAmB,EAAA;EAtQvB;IA0QI,YAAY;IACZ,iBAAiB,EAAA;EA3QrB;IA+QI,WAAU,EAAA;EA/Qd;IAmRI,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB,EAAA;EAvR7B;IA2RI,4BAA4B;IAC5B,WAAW,EAAA;EA5Rf;IAgSI,aAAa,EAAA;EAhSjB;IAoSI,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IAEjB,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,kBAAkB,EAAA;IArTtB;MAyTM,eAAe;MACf,cAAc,EAAA;EA1TpB;IA+TI,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,mBAAmB,EAAA;EAlUvB;IAsUI,gBAAgB;IAChB,YAAY,EAAA;EAvUhB;IA2UI,YAAY;IACZ,iBAAiB;IACjB,mBAAmB,EAAA;EA7UvB;IAkVI,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,8BAA8B;IAC9B,kBAAkB,EAAA;EAtVtB;IA0VI,YAAY;IACZ,2BAA2B;IAC3B,iBAAiB;IACjB,eAAe,EAAA;EA7VnB;IAiWI,gBAAgB;IAChB,YAAY;IACZ,2BAA2B;IAC3B,iBAAiB;IACjB,YAAY,EAAA;EArWhB;IAyWI,cAAc,EAAA;EAzWlB;IA6WI,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,cAAc,EAAA;EAhXlB;IAqXI,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,kBAAkB;IAClB,YAAY;IACZ,WAAW,EAAA;EA5Xf;IAgYI,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,WAAW,EAAA;EAxYf;IA6YI,YAAY;IACZ,yBAAyB;IACzB,sBAAsB;IACtB,oBAAoB,EAAA;EAhZxB;IAoZI,qBAAqB;IACrB,YAAY;IACZ,kBAAkB,EAAA;EAtZtB;IA0ZI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,oBAAoB;IACpB,sBAAsB,EAAA;EAja1B;IAqaI,WAAW;IACX,uBAAuB;IACvB,gCAAgC;IAChC,kCAAkC;IAClC,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB,EAAA;EA3atB;IA+aI,uBAAuB;IACvB,gCAAgC;IAChC,gCAAgC;IAChC,6BAA6B;IAC7B,gBAAgB;IAChB,6BAA6B,EAAA;EApbjC;IAwbI,iBAAiB,EAAA;EAxbrB;IA4bI,kBAAkB;IAClB,yBDnc4B;ICoc5B,kBAAkB;IAClB,6BAA6B,EAAA;EA/bjC;IAmcI,YAAY,EAAA;EAnchB;IAucI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,WAAW,EAAA;IA1cf;MA6cM,sBAAsB;MACtB,aAAa,EAAA;MA9cnB;QAidQ,mBAAmB,EAAA;IAjd3B;MAsdM,yBAAyB,EAAA;EAtd/B;IA2dI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,WAAW,EAAA;IA9df;MAieM,sBAAsB;MACtB,aAAa,EAAA;MAlenB;QAqeQ,mBAAmB,EAAA;IAre3B;MA0eM,yBAAyB,EAAA;EA1e/B;IA+eI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,WAAW,EAAA;IAlff;MAqfM,sBAAsB;MACtB,aAAa,EAAA;MAtfnB;QAyfQ,mBAAmB,EAAA;IAzf3B;MA8fM,yBAAyB,EAAA;;AAM/B;EACE;IAGQ,eAAe,EAAA;EAKvB;IACE,kBAAkB,EAAA;IADpB;MAGI,kBAAkB;MAClB,aAAa;MACb,OAAO,EAAA;EAIX;IACE,kBAAkB,EAAA;IADpB;MAGI,aAAa;MACb,kBAAkB;MAClB,OAAO,EAAA,EACR","sourcesContent":["$primaryFontColor: #fff;\n$secundaryFontColor: #4fc2d9;\n$thirdFontColor: #0b1736;\n$topMenuBackgroundColor: #0b1736;\n$sideBackgroundColor: #002044;\n$sideSubMenuBackgroundColor: #0b1736;\n$fontFamily: 'Urbanist';\n$leftMenuWidth: 5rem;\n$rightMenuWidth: 400px;\n$navBrandImageSize: 150px;\n$darkAndLightModeBackgroundColor: #12234f;\n$dropdownFiltersBackgroundColor: #060e21;\n$inputFocusBackgroundColor: #060e21;\n$containerScreenBackgroundColor: #050e25;\n$tableBackgroundColor: #0b1736;\n$secondarySubtitleColor: #838487;\n\n//FORMS\n$inputBackgroundColor: #021d3e;\n$btnPrimary: #257ee0;\n\n@font-face {\n  font-family: 'Urbanist';\n  src: url('../fonts/Urbanist-VariableFont_wght.ttf');\n}\n","@import \"../../../theme/_variables.scss\";\n\n$paddingLeftSize: 30px;\n$paddingTopSize: 10px;\n$tableDividerLineColor: #222224;\n$tableDividerLineBorderSize: 0.5px;\n$tableFontSize: 1.2vw;\n$positionTop: 140px;\n\n.county-climate {\n  color: $primaryFontColor;\n  background-color: $containerScreenBackgroundColor;\n  height: 100vh;\n  width: 100%;\n  margin: 0px;\n  padding: 0px;\n  padding-left: $paddingLeftSize;\n  padding-right: $paddingLeftSize;\n  padding-top: $paddingTopSize;\n\n\n  h2 {\n    font-weight: 600;\n  }\n\n  .expand-container {\n    position: absolute;\n    top: 65px;\n    left: 70px;\n    height: 90vh !important;\n    width: 95% !important;\n    z-index: 100;\n  }\n\n  .expand-container .table-container {\n    max-height: 80vh !important;\n  }\n\n  .fullscreen,\n  .more-options {\n    background-color: unset;\n    border: unset;\n\n    img {\n      filter: invert(1);\n    }\n  }\n\n  .expand-chart-container {\n    position: absolute !important;\n    top: 80px;\n    left: 95px;\n    height: 90vh !important;\n    width: 92% !important;\n    z-index: 100;\n    margin-top: 0px;\n    max-height: none !important;\n  }\n\n  .expand-summary-container {\n    position: absolute !important;\n    top: 60px;\n    left: 95px;\n    height: 89vh !important;\n    width: 94% !important;\n    z-index: 100;\n    margin-top: 0px;\n    max-height: none !important;\n  }\n\n  .fullscreen:hover {\n    filter: invert(80%) sepia(51%) saturate(6275%) hue-rotate(196deg) brightness(102%) contrast(104%);\n  }\n\n  .more-options:hover {\n    filter: invert(80%) sepia(51%) saturate(6275%) hue-rotate(196deg) brightness(102%) contrast(104%);\n  }\n\n  .container-row-top {\n    margin-top: 10px;\n    height: 40vh;\n  }\n\n  .container-row-bottom {\n    margin-top: 15px;\n    height: 40vh;\n  }\n\n  .chart-container {\n    height: 100%;\n    width: 100%;\n    width: -moz-available;\n    width: -webkit-fill-available;\n    width: stretch;\n    max-height: 40vh;\n  }\n\n  .chart-parent-container {\n    height: 100%;\n    width: 100%;\n    width: -moz-available;\n    width: -webkit-fill-available;\n    width: stretch;\n  }\n\n  .map-report-container {\n    background-color: $topMenuBackgroundColor;\n    border-radius: 2px;\n    box-shadow: 0px 0px 20px #000;\n    display: flex;\n    position: relative;\n    height: 100%;\n  }\n\n  .column-summary {\n    min-width: 120px;\n  }\n\n  .column-chart {\n    margin-left: 10px;\n  }\n\n  .column-container {\n    max-width: 50%;\n  }\n\n  .summary-container {\n    background-color: $topMenuBackgroundColor;\n    border-radius: 2px;\n    box-shadow: 0px 0px 20px #000;\n    display: flex;\n    margin-top: 0px;\n    margin-left: 0px;\n    position: relative;\n    padding-top: 0px;\n    min-width: 120px;\n    overflow-x: hidden;\n    overflow-y: auto;\n    flex-direction: column;\n    border-radius: 7px;\n    font-size: 1.4rem;\n  }\n\n  .summary-container {\n    height: 100%;\n    width: 100%;\n    width: -moz-available;\n    width: -webkit-fill-available;\n    width: stretch;\n    max-height: 40vh;\n  }\n\n  .resultBox-span {\n    color: #49b4cd;\n  }\n\n  .resultBox {\n    margin-top: 5px;\n    margin-left: 20px;\n    font-size: 1.2rem;\n  }\n\n  .resultBoxDescriptor {\n    border-radius: 15px;\n    padding: 6px;\n    margin-top: 10px;\n    width: 100%;\n    background-color: #021b3a;\n    font-family: Helvetica, Arial, sans-serif;\n    padding: 5px;\n    display: inline-block;\n    color: white;\n  }\n\n  .resultsDetail {\n    border-radius: 15px;\n    padding: 6px;\n    margin: 2px;\n    width: 100%;\n    background-color: #021b3a;\n    font-family: Helvetica, Arial, sans-serif;\n    padding: 5px;\n    display: inline-block;\n    clear: both;\n  }\n\n  .resultBox {\n    border-radius: 15px;\n    padding: 6px;\n    margin-top: 10px;\n    background-color: #021b3a;\n    font-family: Helvetica, Arial, sans-serif;\n    padding: 5px;\n    display: inline-block;\n    width: 100%;\n  }\n\n  .resultBoxRow {\n    display: inline-flex;\n    flex-direction: row;\n  }\n\n  .output {\n    width: 160px;\n    padding: 5px 35px 5px 5px;\n    font-size: 1.4rem;\n    color: #49b4cd;\n    height: 34px;\n    margin-left: 5px;\n  }\n\n  .outputLabel {\n    color: white;\n    padding: 5px 10px 5px 5px;\n    font-size: 1rem;\n    /* min-width:50px; */\n    min-width: 90px;\n    display: inline-block;\n  }\n\n  .widgetTitle {\n    margin-top: 4px;\n    margin-left: 8px;\n  }\n\n  .summary-container-secondary {\n    margin-top: 20px;\n  }\n\n  .summary-title {\n    display: flex;\n    width: 110px;\n    white-space: break-spaces;\n    text-align: center;\n    margin-bottom: 1px;\n  }\n\n  .summary-title Button {\n    display: none;\n    margin-left: 15px;\n    background-color: #fff;\n    border: unset;\n  }\n\n  .summary-title img {\n    vertical-align: unset !important;\n  }\n\n  .summary-title Button:hover {\n    background-color: #257ee0;\n  }\n\n  .summary-button {\n    display: none;\n    width: 44px;\n    display: inline-flex;\n    align-self: flex-end;\n    background-color: white;\n  }\n\n  .summary-container-span {\n    font-size: 1.2rem;\n  }\n\n  .summary-top {\n    width: 100px;\n  }\n\n  .summary-field-name {\n    font-size: 12px;\n    color: gray;\n    padding-bottom: 5px;\n  }\n\n  .summary-field-double {\n    height: auto;\n    line-height: 18px;\n  }\n\n  .mapboxgl-popup {\n    z-index:22;\n  }\n\n  .mapboxgl-popup-content {\n    padding: 0px !important;\n    opacity: .95;\n    border-radius: 4px;\n    width: 100% !important;\n    background-color: #18244c;    \n  }\n\n  .mapboxgl-popup-anchor-top .mapboxgl-popup-tip {\n    border-bottom-color: #050E25;\n    opacity: .8;\n  }\n\n  .mapboxgl-popup-close-button {\n    display: none;\n  }\n\n  .popup-container {\n    background-color: black;\n    opacity: .95;\n    text-align: center;\n    height: auto;\n    padding-top: 10px;\n    padding-bottom: 18px;\n    padding-left: 10px;\n    padding-right: 4px;\n    font-size: 1.2rem;\n \n    min-width: 210px;\n    line-height: 1.2rem;\n    font-family: \"Urbanist\";\n    background-color: #050E25;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    width: max-content;\n   \n\n    h2 {\n      font-size: 22px;\n      color: #49b4cd;\n    }\n  }\n\n  .popup-content-left {\n    text-align: right;\n    margin-right: 10px;\n    width: 75px;\n    white-space: normal;\n  }\n\n  .popup-content-right {\n    text-align: left;\n    width: 200px;\n  }\n\n  .popup-content-right-double {\n    height: 32px;\n    line-height: 18px;\n    margin-bottom: 25px;\n  }\n\n  \n  .popup-content-row {\n    display: inline-flex;\n    flex-direction: row;\n    height: auto;\n    justify-content: space-between;\n    margin-bottom: 7px;\n  }\n\n  .popup-content-label {\n    width: 100px;\n    min-width: 100px !important;\n    margin-right: 5px;\n    text-align: end;\n  }\n\n  .popup-content-value {\n    margin-left: 5px;\n    width: 160px;\n    max-width: 160px !important;\n    text-align: start;\n    height: auto;\n  }\n\n  .popup-container-location {\n    color: #4fc2d9;\n  }\n\n  .popup-container h4 {\n    font-size: 22px;\n    line-height: 22px;\n    height: auto;\n    color: #4fc2d9;\n  }\n\n\n  .map-title {\n    width: auto;\n    white-space: nowrap;\n    position: absolute;\n    left: 50px;\n    top: 0px;\n    font-size: 1.25rem;\n    padding: 5px;\n    z-index: 90;\n  }\n\n  .map-legend {\n    width: 125px;\n    min-height: auto;\n    position: absolute;\n    border-radius: 5px;\n    padding: 5px;\n    right: 30px;\n    bottom: 5px;\n    background-color: #18244c;\n    z-index: 90;\n  }\n\n\n  .accordion-button {\n    color: white;\n    background-color: #18244c;\n    border: 0px !important;\n    padding: .5rem .5rem;\n  }\n\n  .climate-slider {\n    display: inline-block;\n    width: 330px;\n    align-self: center;\n  }\n\n  .climate-slider-container {\n    width: 100%;\n    position: absolute;\n    bottom: 30px;\n    text-align: center;\n    padding-right: 10px;\n    height: 90px;\n    display: inline-flex;\n    flex-direction: column;\n  }\n\n  .climate-slider-container-span{\n    width: 100%;\n    color: white !important;\n    -webkit-text-stroke-width: 1.2px;\n    -webkit-text-stroke-color: #060e21;\n    text-align: center;\n    font-size: 1.5rem;\n    margin-bottom: 7px;\n  }\n\n  .rc-slider-mark-text {\n    color: white !important;\n    -webkit-text-stroke-width: 1.4px;\n    -webkit-text-stroke-color: black;\n    font-size: 1.2rem  !important;\n    font-weight: 700;\n    text-shadow: unset !important;\n  }\n\n  .chart-container-parent {\n    margin-left: 10px;\n  }\n\n  .chart-container {\n    position: relative;\n    background-color: $topMenuBackgroundColor;\n    border-radius: 2px;\n    box-shadow: 0px 0px 20px #000;\n  }\n\n  .line-chart {\n    height: 100%;\n  }\n\n  .report-chart-options-camel {\n    position: absolute;\n    margin-top: 5px;\n    text-align: right;\n    right: 10px;\n\n    button {\n      background-color: #fff;\n      border: unset;\n\n      img {\n        padding-bottom: 3px;\n      }\n    }\n\n    .btn-light:hover {\n      background-color: #257ee0;\n    }\n  }\n\n  .report-chart-options-storm {\n    position: absolute;\n    margin-top: 5px;\n    text-align: right;\n    right: 10px;\n\n    button {\n      background-color: #fff;\n      border: unset;\n\n      img {\n        padding-bottom: 3px;\n      }\n    }\n\n    .btn-light:hover {\n      background-color: #257ee0;\n    }\n  }\n\n  .report-chart-options-summary {\n    position: absolute;\n    margin-top: 5px;\n    text-align: right;\n    right: 10px;\n\n    button {\n      background-color: #fff;\n      border: unset;\n\n      img {\n        padding-bottom: 3px;\n      }\n    }\n\n    .btn-light:hover {\n      background-color: #257ee0;\n    }\n  }\n\n}\n\n@media only screen and (min-device-width: 768px) and (max-device-width: 1366px) and (orientation: portrait) {\n  .county-climate {\n    .header-container {\n        h2 { \n          font-size: 23px; \n        }\n    }\n  }\n\n  .line-chart {\n    position: relative;\n    canvas {\n      position: absolute;\n      padding: 3rem;\n      top: 1%;\n    }\n  }\n\n  .container-q3 {\n    position: relative;\n    .line-q3 {\n      padding: 2rem;\n      position: absolute;\n      top: 2%;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
